module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="card-close-icon"><span class="glyphicon glyphicon-remove"></span></div>\n';

}
return __p
}